import { LOGIN_SUCCESS, LOGIN_REQUEST, LOGIN_FAILURE, LOGOUT, SOCKET_STATE_CHANGE, SOCKET_MESSAGE, STUDY_PATHNAME } from '../constants/ActionTypes';
import { STATE_START } from '../middleware/socketIOMiddleware';

const user = JSON.parse(localStorage.getItem('user'));

const initialState = () => {
  const initialState = {
    isLoggedIn: false,
    ...(user ? { user } : {}),
    stateSocketIO: STATE_START,
    studyPathname: undefined,
    messageSocketIO: 'Connecting...', // si es undefined, no muestra error y si tiene algo, muestralo en las rutas
    isLoggingIn: false,
    messageError: undefined,
  };

  return initialState;
};

export default (state = initialState(), action) => {
  switch (action.type) {
    case LOGIN_REQUEST:
      return {
        ...state,
        isLoggingIn: true,
      };

    case LOGIN_SUCCESS:
      return {
        ...state,
        isLoggedIn: true,
        isLoggingIn: false,
        user: action.user,
      };

    case LOGIN_FAILURE:
      return { ...state, isLoggedIn: false, isLoggingIn: false, user: undefined, messageError: action.error };

    case LOGOUT:
      return { ...state, isLoggedIn: false, isLoggingIn: false, user: undefined };

    case STUDY_PATHNAME: {
      return {
        ...state,
        studyPathname: action.pathname,
      };
    }

    case SOCKET_STATE_CHANGE: {
      return {
        ...state,
        stateSocketIO: action.payload.state,
      };
    }

    case SOCKET_MESSAGE: {
      return {
        ...state,
        messageSocketIO: action.payload,
      };
    }

    default:
      return state;
  }
};
